<template>
    <section class="video">
        <slot name="titre"></slot>
        <div class="video-container">
            <transition name="fade">
                <div class="img-back" v-if="!play" :style="'background-image: url('+imgurl+')'" @click="startVideo">
                    <span class="icon-play-video" v-if="showPlayLogo"></span>
                    <div class="lds-ring" v-else>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </transition>
            <slot name="video"></slot>
        </div>
        <p class="legende">
            <slot name="legende"></slot>
        </p>
    </section>
</template>

<script>
    import $ from "jquery";

    export default {
        props: ['imgurl'],
        data() {
            return {
                play: false,
                showPlayLogo: true
            };
        },
        methods: {
            startVideo(event) {
                this.showPlayLogo = false
                setTimeout(() => {
                    this.play = true
                }, 1000)
                $(event.target).closest(".video-container").find("iframe")[0].src += "&autoplay=1"
            }
        },
        mounted() {
            if (this.imgurl === ""){
                this.play = true
            }
        },
        destroyed() {
        }
    };
</script>
